/** Thai strings for the paper fortune teller (English source text -> Thai). */
export const FORTUNE: Record<string, string> = {
  'Paper Fortune Teller': 'กระดาษพับทายใจ',
  Fortune: 'ทายใจ',
  "Free tickets: one every day, and one more for finishing all of today's quests (keep up to {max}). Tickets are never sold.":
    'ตั๋วฟรี: วันละ 1 ใบ และได้เพิ่มอีก 1 ใบเมื่อทำภารกิจวันนี้ครบ (เก็บได้สูงสุด {max} ใบ) ตั๋วไม่มีขาย',
  "Here is today's free fortune ticket!": 'รับตั๋วทายใจฟรีของวันนี้แล้ว!',
  "No tickets left. Come back tomorrow or finish today's quests!": 'ตั๋วหมดแล้ว พรุ่งนี้มาใหม่ หรือทำภารกิจวันนี้ให้ครบนะ!',
  "No tickets yet. Come back tomorrow or finish today's quests!": 'ยังไม่มีตั๋ว พรุ่งนี้มาใหม่ หรือทำภารกิจวันนี้ให้ครบนะ!',
  "That was your last ticket. Come back tomorrow or finish today's quests!": 'นั่นคือตั๋วใบสุดท้ายแล้ว พรุ่งนี้มาใหม่ หรือทำภารกิจวันนี้ให้ครบนะ!',
  '+1 fortune ticket': 'ตั๋วทายใจ +1',
  '+{coins} coins': '+{coins} เหรียญ',
  'A free fortune is waiting!': 'มีตั๋วทายใจฟรีรออยู่!',
  'Tap to play the paper fortune teller.': 'แตะเพื่อเล่นกระดาษพับทายใจ',
  'Free ticket waiting!': 'มีตั๋วฟรีรออยู่!',
  'Play!': 'เล่นเลย!',
  'Tickets: {n} / {max}': 'ตั๋ว: {n} / {max}',
  'Odds: what can I win?': 'โอกาสได้รางวัล: ได้อะไรบ้าง?',
  'Every {n}th draw in a row without a rare or epic prize is at least rare.': 'ถ้าเล่นติดกัน {n} ครั้งโดยไม่ได้รางวัลหายากหรือสุดยอดเลย ครั้งนั้นจะได้อย่างน้อยระดับหายากแน่นอน',
  'Already have every pen (or stamp)? You get its shop price in coins instead.': 'ถ้ามีปากกา (หรือตราประทับ) ครบทุกแบบแล้ว จะได้เหรียญเท่าราคาในร้านแทน',
  'Colours, numbers and flaps are just for fun: every draw has the same odds.': 'สี ตัวเลข และกลีบที่เลือกมีไว้สนุกเท่านั้น ทุกครั้งมีโอกาสได้รางวัลเท่ากัน',
  'Pick a colour!': 'เลือกสีเลย!',
  'Spelling {word}…': 'กำลังสะกด {word}…',
  'Pick a number!': 'เลือกตัวเลข!',
  'Counting to {n}…': 'กำลังนับถึง {n}…',
  'Pick a flap to lift!': 'เลือกกลีบที่จะเปิด!',
  'Your fortune:': 'คำทำนายของคุณ:',
  'Play again ({n} left)': 'เล่นอีกครั้ง (เหลือ {n} ใบ)',
  'You won the {item}!': 'ได้ {item}!',
  'You already have every gel pen, so here is the price of the {item} in coins.': 'มีปากกาเจลครบทุกสีแล้ว เลยได้เหรียญเท่าราคา{item}แทน',
  'You already have every victory stamp, so here is the price of the {item} in coins.': 'มีตราประทับครบทุกแบบแล้ว เลยได้เหรียญเท่าราคา{item}แทน',
  'Lucky streak! This draw was at least rare.': 'โชคช่วย! ครั้งนี้ได้อย่างน้อยระดับหายาก',
  'Fortune teller prize: {item}': 'รางวัลจากกระดาษพับทายใจ: {item}',

  // Rarity tiers and prizes (data/fortune.ts)
  Common: 'ธรรมดา',
  Rare: 'หายาก',
  Epic: 'สุดยอด',
  '{min}–{max} coins': '{min}–{max} เหรียญ',
  'A gel pen you do not have yet': 'ปากกาเจลสีที่ยังไม่มี',
  'A victory stamp you do not have yet': 'ตราประทับที่ยังไม่มี',

  // Outer flap colours, spelled out letter by letter in the game
  BLUE: 'ฟ้า',
  PINK: 'ชมพู',
  GREEN: 'เขียว',
  YELLOW: 'เหลือง',

  // Fortunes under the flaps
  'Your next doodle will make someone smile.': 'รูปที่วาดต่อไปจะทำให้ใครบางคนยิ้ม',
  'A brave monster is about to meet its match: you!': 'มอนสเตอร์ตัวเก่งกำลังจะเจอคู่ปรับ นั่นก็คือเธอ!',
  'Today is a great day to try a new colour.': 'วันนี้เหมาะกับการลองสีใหม่สุดๆ',
  'Your pencil is full of good ideas.': 'ดินสอของเธอเต็มไปด้วยไอเดียดีๆ',
  'A friend will cheer for you soon.': 'อีกไม่นานจะมีเพื่อนส่งเสียงเชียร์เธอ',
  'Rock, paper or scissors? Trust your gut!': 'ค้อน กระดาษ หรือกรรไกร? เชื่อใจตัวเองเลย!',
  'Something wiggly is waiting in your next drawing.': 'มีอะไรดุ๊กดิ๊กรออยู่ในรูปวาดต่อไป',
  'You will find a gold star where you least expect it.': 'เธอจะเจอดาวทองในที่ที่ไม่คาดคิด',
  'Your hero is getting stronger every day.': 'ฮีโร่ของเธอเก่งขึ้นทุกวัน',
  'Kindness is your secret super move.': 'ความใจดีคือท่าไม้ตายลับของเธอ',
  'Mistakes are just doodles in disguise.': 'ที่วาดพลาด จริงๆ ก็คือรูปวาดที่ปลอมตัวมา',
  'A big adventure starts with a small sketch.': 'การผจญภัยครั้งใหญ่เริ่มจากรูปวาดเล็กๆ',
  'Someone will love the monster you draw next.': 'จะมีคนหลงรักมอนสเตอร์ตัวต่อไปที่เธอวาด',
  'Practice makes paper legends.': 'ฝึกบ่อยๆ แล้วจะเป็นตำนานแห่งสมุด',
  'Your lucky number is the one you picked!': 'เลขนำโชคของเธอคือเลขที่เพิ่งเลือกนั่นแหละ!',
  'Smile! Your notebook is proud of you.': 'ยิ้มหน่อย! สมุดภูมิใจในตัวเธอนะ',
};
